import { IconContent } from '@icons';

export const chevronDown: IconContent = {
    sm: '<path d="M12.854 6.104 8 10.957 3.146 6.104l.708-.708L8 9.543l4.146-4.147.708.708Z" />',
    md: '<path d="m11.646 15.354-6-6 .708-.708L12 14.293l5.646-5.647.708.708-6 6-.354.353-.354-.353Z" />',
};
